export default __webpack_public_path__ + "static/media/idea.b3be9ec0.png";